module.exports = __webpack_public_path__ + "static/media/caret-up-light.1a84a216.svg";